import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { NavBar } from '../../components/layout/NavBar';
import './Teltonika.module.css'
import { Services } from '@/services/services';
import { Object, SimpleObject } from '@/services/model/object';
import { MainLayout } from '@/components/layout/MainLayout';
import { CurrentSession } from '@/services/repository/session';


export const TeltonikaPage = ({services, session}: {services: Services, session: CurrentSession}) => {
  const navigate = useNavigate();
  const [list, setList] = useState<string[]>()

  useEffect(() => {
    services.teltonika.list().then((data) => setList(data || []))
  }, []);

  function renderRow(imei: string) {
    return (<li onClick={()=>navigate('/service/teltonika/'+imei)}>
      {imei}
    </li>)
  }

  return <MainLayout services={services} pageName='teltonika' session={session} translates={session.translates}>
    <h2>Teltonika</h2>
    {list !== null ? list?.length === 0 ? (<div>Empty</div>) : list?.map((row) => renderRow(row)) : <div className='spinner'></div>}
  </MainLayout>
};
